import VerifyEmailError from './VerifyEmailError';
class InvalidEmailToken extends VerifyEmailError {
    constructor(options) {
        super('Token given to validate email is invalid', options);
    }
}
export default InvalidEmailToken;
